import api from '../../api';

export const studentAccountService = {
    getSchool: async () => {
        try {
            const response = await api.get('/students/school');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    setSchool: async (schoolId) => {
        try {
            const response = await api.post('/students/school', { schoolId });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    clearSchool: async () => {
        try {
            const response = await api.delete('/students/school');
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};
